module.exports = __webpack_public_path__ + "frontend/img/icon-result-20-50.b07d14c2.svg";